module.exports = __webpack_public_path__ + "img/game--fifa-22--pegi.0b463a79.png";